import React, { useState } from 'react';
import { Button, IconButton, Menu, MenuItem, Box, Tooltip } from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

interface DashboardSwitcherProps {
  variant?: 'button' | 'icon';
  size?: 'small' | 'medium' | 'large';
}

const DashboardSwitcher: React.FC<DashboardSwitcherProps> = ({ 
  variant = 'button',
  size = 'medium'
}) => {
  const { userProfile } = useAuth();
  const navigate = useNavigate();
  
  // Since we only have business purpose now, no need for this component
  return null;
};

export default DashboardSwitcher; 